export default "<p>invoice-view works!</p>\r\n"